exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".article{margin-bottom:100px}.result{margin-left:-8px;padding:24px;background-color:#e3dce7}@media screen and (max-device-width:768px){.result{margin-left:-24px;margin-right:-24px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-afe0e362","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/result.vue
// module id = 730
// module chunks = 0